import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const batchOptionManage: AppRouteModule = {
  path: '/batchOptionManage',
  name: 'BatchOptionManage',
  identify: 'batchOptionManage',
  component: LAYOUT,
  redirect: '/batchOptionManage/batchOptionIndex',
  meta: {
    icon: 'icon-park-outline:add-print',
    title: '批量操作',
    roles: [RoleEnum.OFFLINE],
  },
  children: [ 
    // 列表页面
    {
      path: 'batchOptionIndex',
      name: 'BatchOptionIndex',
      component: () => import('@/views/batchOptionManage/batchOptionIndex/index.vue'),
      identify: 'batchOptionIndex',
      meta: {
        title: '批量操作',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};
export default batchOptionManage;
